// React App
import React from 'react'
import ReactDOM from 'react-dom'
import Minicart from './minicart'

class RApp {
  constructor() {
    this.MinicartComponent = null
  }

  init() {
    ReactDOM.render((<Minicart />), document.getElementById('react-minicart-component'))
  }
}

const rApp = new RApp()
export default rApp
